import { IconName } from '@infotech-soe/erp-ui-kit';
import { IContextMenuInteractItem, THotKey } from '@infotech-soe/metaschema';

import { Caption } from '../../models/caption/Caption';
import { ClientContext } from '../context/IContextService';

import { CommandName } from './CommandViewModel';
import { UserInteractor } from './UserInteractor';
import CategoryCommand, { RefreshStrategy } from './wrap/CategoryCommand';

class CommandDecorator<T> extends CategoryCommand<T> {
  constructor(
    private command: CategoryCommand<T>,
    private item: IContextMenuInteractItem
  ) {
    super(command.getCommandImpl());
  }

  public isAvailable(context: ClientContext): boolean {
    if (!super.isAvailable(context)) {
      return false;
    }

    return this.item.availability
      ? this.item.availability({
          row: context.get('Row') || {},
          parentRow: context.get('ParentRow') || {},
          masterRow: context.get('MasterRow') || {},
          catalog: context.get('Catalog'),
          inParams: context.get('InParams'),
          selectedIds: context.get('SelectedIds') || [],
        })
      : true;
  }

  public execute(
    context: ClientContext,
    args: T
  ): Promise<void | Record<string, any>> {
    return this.command.execute(context, args);
  }

  public getInitialArgs(
    context: ClientContext,
    currentRecord?: Record<string, any>
  ): Promise<T> {
    return this.command.getInitialArgs(context, currentRecord);
  }

  public getUserInteractor(): Promise<UserInteractor> {
    return this.command.getUserInteractor();
  }

  public getName(): CommandName {
    return this.command.getName();
  }

  public getRefreshStrategy(): RefreshStrategy {
    return this.command.getRefreshStrategy();
  }

  public getIcon(): IconName {
    return this.command.getIcon();
  }

  public getHotKey(): THotKey | undefined {
    return this.command.getHotKey();
  }

  public getCaption(): Promise<Caption> {
    return this.command.getCaption();
  }

  public getMenuLabel(): string | undefined {
    return this.command.getMenuLabel();
  }

  public getBadge(context: ClientContext): string | number | undefined {
    const result = this.item.badge?.({
      row: context.get('Row') || {},
      parentRow: context.get('ParentRow') || {},
      masterRow: context.get('MasterRow') || {},
      catalog: context.get('Catalog'),
      inParams: context.get('InParams'),
      selectedIds: context.get('SelectedIds') || [],
    });

    if (typeof result === 'boolean') {
      return result ? '✓' : '';
    }
    return result;
  }
}

export default CommandDecorator;
